import { ImageMarkerOutlineIcon } from './ImageMarkerOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 754F7051-3979-499F-B7E6-9513619D7609
 * name image-marker-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-marker-outline.svg
 * tags
 * - Navigation 
 */
export const ImageLocationOutlineIcon = ImageMarkerOutlineIcon;
export default ImageLocationOutlineIcon